import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { LeafletModule } from '@bluehalo/ngx-leaflet';
import {
  GcButtonComponent,
  GcCheckboxComponent,
  GcDropdownButtonComponent,
  GcIconComponent,
  GcInputFieldComponent,
  GcLinkComponent,
  GcListItemComponent,
  GcLoadingSpinnerComponent,
  GcModalComponent,
  GcPillComponent,
  GcTabComponent,
  GcTabsComponent,
  GcTextComponent,
  GcTooltipComponent,
  IpoAlertComponent,
  IpoBorderlessButtonComponent,
  IpoButtonComponent,
  IpoCheckboxComponent,
  IpoClickOutsideDirective,
  IpoDatepickerComponent,
  IpoDropdownComponent,
  IpoFilterByPropertiesPipe,
  IpoFlexibleTableModule,
  IpoFormDatepickerComponent,
  IpoFormInputComponent,
  IpoIconAlertComponent,
  IpoInputAutoCompleteComponent,
  IpoInputComponent,
  IpoLanguageService,
  IpoLetDirectiveModule,
  IpoLoadingSpinnerComponent,
  IpoModalComponent,
  IpoPaginationComponent,
  IpoProgressComponent,
  IpoRadioComponent,
  IpoSkeletonComponent,
  IpoSliderComponent,
  IpoSortByPipe,
  IpoStringService,
  IpoSvgIconComponent,
  IpoSwitchComponent,
  IpoTableModule,
  IpoTabsModule,
  IpoTagListComponent,
  IpoTextComponent,
  IpoTooltipModule,
  IpoTranslateArrayPipe,
  IpoTranslatePipe,
  stringServiceFactory,
} from '@ip-only/front-end-library';
import { ErrorInformationComponent } from '../shared/error-information/error-information.component';
import { FeedbackAlertComponent } from '../shared/feedback-alert/feedback-alert.component';
import { CompleteReportConfirmationModalComponent } from '../shared/installation-report-content-v2/complete-report-confirmation-modal/complete-report-confirmation-modal.component';
import { SharedModule } from '../shared/shared.module';
import { DuctPopupContentComponent } from '../shared/spanprogress-landsurvey/duct-popup-content/duct-popup-content.component';
import { ExistingSpanPipe } from '../shared/util/existing-span.pipe';
import { IdMapperPipeModule } from '../shared/util/id-mapper.pipe';
import { PropertySpanPipe } from '../shared/util/property-span.pipe';
import { OfflineCheckInterceptor } from './service/offline-check.interceptor';
import { FilterOptionsPipe } from './span-progress-report/filter-options/filter-options.pipe';
import { InstallationReportModalV2Component } from './span-progress-report/installation-report-modal-v2/installation-report-modal-v2.component';
import { HcTableComponent } from './span-progress-report/multi-point-modal/hc-wrapper/hc-table/hc-table.component';
import { HcWrapperComponent } from './span-progress-report/multi-point-modal/hc-wrapper/hc-wrapper.component';
import { HpTableComponent } from './span-progress-report/multi-point-modal/hp-table/hp-table.component';
import { MultiPointModalComponent } from './span-progress-report/multi-point-modal/multi-point-modal.component';
import { WellTableComponent } from './span-progress-report/multi-point-modal/well-table/well-table.component';
import { OrdersOverviewModalComponent } from './span-progress-report/orders-overview-modal/orders-overview-modal.component';
import { OrdersOverviewTableComponent } from './span-progress-report/orders-overview-modal/orders-overview-table/orders-overview-table.component';
import { PlacementImageLinkComponent } from './span-progress-report/placement-image-link/placement-image-link.component';
import { ReportStatusComponent } from './span-progress-report/report-status/report-status.component';
import { SpanProgressReportComponent } from './span-progress-report/span-progress-report.component';
import { SpanProgressRoutingModule } from './span-progress-routing.module';
import { DuctSearchPipe } from './span-progress-view/duct-table/duct-search-pipe';
import { DuctTableComponent } from './span-progress-view/duct-table/duct-table.component';
import { MapControlsComponent } from './span-progress-view/map-controls/map-controls.component';
import { MapInteractionService } from './span-progress-view/map-interaction/map-interaction.service';
import { MapComponent } from './span-progress-view/map/map.component';
import { ButtonPopupContainerComponent } from './span-progress-view/popup-content/components/button-popup-container/button-popup-container.component';
import { DuctListPopupContentComponent } from './span-progress-view/popup-content/components/duct-list-popup-content/duct-list-popup-content.component';
import { PdfDownloadTriggerComponent } from './span-progress-view/popup-content/components/pdf-download-trigger/pdf-download-trigger.component';
import { ReportablePopupShellComponent } from './span-progress-view/popup-content/components/reportable-popup-shell/reportable-popup-shell.component';
import { TextPopupContainerComponent } from './span-progress-view/popup-content/components/text-popup-container/text-popup-container.component';
import { DistributionPopupContentComponent } from './span-progress-view/popup-content/distribution-popup-content/distribution-popup-content.component';
import { DuctContentComponent } from './span-progress-view/popup-content/duct-content/duct-content.component';
import { DuctCrossSectionComponent } from './span-progress-view/popup-content/duct-content/duct-cross-section/duct-cross-section.component';
import { SpanDuctComponent } from './span-progress-view/popup-content/duct-content/span-duct/span-duct.component';
import { DuctpointPopupContentComponent } from './span-progress-view/popup-content/ductpoint-popup-content/ductpoint-popup-content.component';
import { HouseholdsPopupContentComponent } from './span-progress-view/popup-content/households-popup-content/households-popup-content.component';
import { InfoPopupContentComponent } from './span-progress-view/popup-content/info-popup-content/info-popup-content.component';
import { PermitAreaPopupContentComponent } from './span-progress-view/popup-content/permit-area-popup-content/permit-area-popup-content.component';
import { PopupContentComponent } from './span-progress-view/popup-content/popup-content.component';
import { ReportButtonComponent } from './span-progress-view/popup-content/report-button/report-button.component';
import { ReportablePointPopupContentComponent } from './span-progress-view/popup-content/reportable-point-popup-content/reportable-point-popup-content.component';
import { SpanPopupContentComponent } from './span-progress-view/popup-content/span-popup-content/span-popup-content.component';
import { ReportsPanelComponent } from './span-progress-view/reports-panel/reports-panel.component';
import { SelectSpanModeComponent } from './span-progress-view/select-span-mode/select-span-mode.component';
import { SpanProgressViewComponent } from './span-progress-view/span-progress-view.component';
import en from './strings.en';
import fi from './strings.fi';
import sv from './strings.sv';
import { DuctDbNamePipe } from './utils/duct-db-name.pipe';
import { PointLabelPipe } from './utils/point-label.pipe';
import { KpReportStatusPipe } from './utils/kp-report-status.pipe';
import { PointTooltipPipe } from './utils/point-tooltip.pipe';

@NgModule({
  imports: [
    OverlayModule,
    CommonModule,
    SpanProgressRoutingModule,
    SharedModule,
    IdMapperPipeModule,
    IpoTranslatePipe,
    IpoTranslateArrayPipe,
    IpoModalComponent,
    IpoAlertComponent,
    IpoSvgIconComponent,
    IpoButtonComponent,
    IpoBorderlessButtonComponent,
    IpoFormInputComponent,
    IpoDropdownComponent,
    IpoTagListComponent,
    IpoCheckboxComponent,
    IpoLoadingSpinnerComponent,
    IpoPaginationComponent,
    IpoInputComponent,
    IpoRadioComponent,
    IpoSliderComponent,
    IpoDatepickerComponent,
    IpoFlexibleTableModule,
    IpoTableModule,
    IpoTabsModule,
    IpoSwitchComponent,
    IpoProgressComponent,
    IpoCheckboxComponent,
    IpoFormDatepickerComponent,
    IpoSkeletonComponent,
    IpoFilterByPropertiesPipe,
    IpoSortByPipe,
    IpoIconAlertComponent,
    IpoTextComponent,
    IpoClickOutsideDirective,
    IpoLetDirectiveModule,
    IpoTooltipModule,
    IpoLetDirectiveModule,
    IpoInputAutoCompleteComponent,
    GcTextComponent,
    GcButtonComponent,
    GcDropdownButtonComponent,
    GcInputFieldComponent,
    GcListItemComponent,
    GcLoadingSpinnerComponent,
    GcIconComponent,
    GcModalComponent,
    GcTooltipComponent,
    GcTabsComponent,
    GcTabComponent,
    ButtonPopupContainerComponent,
    PdfDownloadTriggerComponent,
    TextPopupContainerComponent,
    GcPillComponent,
    SelectSpanModeComponent,
    FeedbackAlertComponent,
    CompleteReportConfirmationModalComponent,
    ErrorInformationComponent,
    LeafletModule,
    PropertySpanPipe,
    ExistingSpanPipe,
    DuctPopupContentComponent,
    DuctContentComponent,
    SpanDuctComponent,
    GcCheckboxComponent,
    GcLinkComponent,
  ],
  declarations: [
    SpanProgressViewComponent,
    MapComponent,
    MapControlsComponent,
    SpanPopupContentComponent,
    SpanProgressReportComponent,
    FilterOptionsPipe,
    DuctSearchPipe,
    InfoPopupContentComponent,
    DuctpointPopupContentComponent,
    PopupContentComponent,
    DistributionPopupContentComponent,
    ReportStatusComponent,
    ReportButtonComponent,
    ReportablePopupShellComponent,
    HouseholdsPopupContentComponent,
    DuctCrossSectionComponent,
    DuctTableComponent,
    ReportsPanelComponent,
    OrdersOverviewModalComponent,
    OrdersOverviewTableComponent,
    PlacementImageLinkComponent,
    InstallationReportModalV2Component,
    PermitAreaPopupContentComponent,
    ReportablePointPopupContentComponent,
    MultiPointModalComponent,
    DuctListPopupContentComponent,
    DuctDbNamePipe,
    PointLabelPipe,
    KpReportStatusPipe,
    PointTooltipPipe,
    HpTableComponent,
    HcWrapperComponent,
    HcTableComponent,
    WellTableComponent,
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: OfflineCheckInterceptor,
      multi: true,
    },
    {
      provide: IpoStringService,
      useFactory: stringServiceFactory({ en, sv, fi }),
      deps: [IpoLanguageService],
    },
    MapInteractionService,
    IpoTranslatePipe,
    PropertySpanPipe,
    ExistingSpanPipe,
  ],
})
export class SpanProgressModule {}
